<template>
  <EligibilityData :id="id">
    <div class="eligibility-dialog" slot-scope="{ eligibility, loading}">
      <can I="read" a="Eligibility">
        <v-fade-transition name="v-fade-transition">
          <v-card
            v-show="showFloatingHeader"
            flat
            class="text-xs-center floating-profile-header"
          >
            <v-layout row align-start justify-space-around class="mt-2 mx-1">
              <v-flex xs4 class="text-xs-left">
                <v-layout row :wrap="$vuetify.breakpoint.mdOnly">
                  <v-menu bottom right offset-y
                    :close-on-content-click="false"
                    max-width="400"
                    max-height="50vh"
                  >
                    <v-btn
                      slot="activator"
                      small
                      :icon="$vuetify.breakpoint.smAndDown" color="secondary"
                    >
                      <v-icon small>mdi-folder</v-icon>
                    </v-btn>
                    <v-card dark>
                      <EligibilityDocuments :eligibility="eligibility" />
                    </v-card>
                  </v-menu>
                </v-layout>
              </v-flex>

              <v-flex xs4>
                <div class="text-xs-center" style="margin-top: -40px;">
                  <v-avatar size="80">
                    <img
                      v-if="eligibility.profile && eligibility.profile.avatar"
                      :src="eligibility.profile.avatar"
                    />
                    <img v-else src="/img/missing/avatars/original.png" />
                  </v-avatar>
                </div>
                <div class="headline">
                  <router-link :to="`/profiles/${eligibility.profile.id}`" v-if="eligibility.profile && eligibility.profile.firstName" style="text-decoration: none">
                    {{ eligibility.profile.firstName }}
                  </router-link>
                </div>
              </v-flex>
              <v-flex xs4>
              </v-flex>
            </v-layout>
          </v-card>
        </v-fade-transition>
        <!-- Eligibility Dialog -->
        <v-dialog
          width="70vw"
          :value="id > 0"
          lazy
          transition="scale-transition"
          @update:returnValue="$emit('close')"
        >
        <!-- Loading Indicator -->
          <v-card dark :class="{'pt-3': showFloatingHeader}">
            <div v-if="loading" key="eligibility-loading-indicator">
              <div class="text-xs-center pa-3" >
                <v-progress-circular size="150" indeterminate>
                  <v-avatar size="140" >
                    <img
                      v-if="eligibility && eligibility.profile && eligibility.profile.avatar"
                      :src="eligibility.profile.avatar"
                    />
                    <img v-else src="/img/missing/avatars/original.png" />
                  </v-avatar>
                </v-progress-circular>
                <div class="headline" v-if="eligibility && eligibility.profile">
                  <span v-if="eligibility.profile.firstName">{{ eligibility.profile.firstName }}</span>
                </div>
              </div>
            </div>
            <!-- Scrollable Eligibility Div -->
              <div
              v-else key="eligibility-details"
              id="profile-container"
              v-scroll:#profile-container="onScroll"
              style="overflow-y: scroll; overflow-x: hidden; margin-bottom: 3rem;"
              :style="{'max-height': profileHeight}"
              >
                <Eligibility :eligibility="eligibility" />
              </div>
              <!-- Bottom Toolbar -->
              <v-card-title class="pa-0" v-if="!loading && canEdit">
                <can I="read" a="Eligibility">
                  <CandidateQuickActionToolbar :candidate="eligibility" @done="$emit('close')" />
                </can>
              </v-card-title>
          </v-card>
        </v-dialog>
      </can>
    </div>
  </EligibilityData>
</template>

<script>
// Components
import CandidateQuickActionToolbar from '@/components/applications_tracker/CandidateQuickActionToolbar'
import Eligibility from '@/components/applications_tracker/eligibilities/Eligibility'
import EligibilityData from '@/components/applications_tracker/eligibilities/EligibilityData'
import EligibilityDocuments from '@/components/applications_tracker/eligibilities/EligibilityDocuments'

//helpers
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: { id: Number },
  components: {
    CandidateQuickActionToolbar,
    Eligibility,
    EligibilityData,
    EligibilityDocuments
  },
  data() {
    return {
      showFloatingHeader: false,
      width: 750,
      canEdit: true
    }
  },

  computed: {
    profileHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '80vh'
        case 'sm':
          return '82vh'
        case 'md':
          return '82vh'
        case 'lg':
          return '82vh'
        case 'xl':
          return '82vh'
      }
    }
  },
  methods: {
    onScroll(e) {
      this.showFloatingHeader = e.target.scrollTop > 150
    }
  }
}
</script>

<style>
.eligibility-dialog nav div.v-toolbar__content {
  padding: 0;
}

.eligibility-dialog .floating-profile-header {
  position: fixed;
  top: 6vh;
  width: 70vw;
  z-index: 10001;
  left: 50%;
  transform: translateX(-50%);
}

.eligibility-dialog .floating-profile-header a.headline {
  text-decoration: none;
}

.eligibility-dialog .floating-profile-header .v-btn--icon,
.eligibility-dialog .floating-profile-header .v-btn--icon::before {
  border-radius: inherit;
}
</style>
